import { AttachmentType } from "./Enums";

export class PointCategoryModel {

    public constructor(init?: Partial<Pick<PointCategoryModel, keyof PointCategoryModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number
    name = '';
    logoUrl = '';
    description = '';
    ordinal: number;


    // Variable Local, Se utiliza para mostrar en la vista
    templates: PointTemplateModel[] = [];
}

export class PointTemplateModel {

    public constructor(init?: Partial<Pick<PointTemplateModel, keyof PointTemplateModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number
    name = '';
    logoUrl = '';
    imageUrl ='';
    description = '';

    categories: number[] = [];
}

export class UploadImageModel {

    public constructor(init?: Partial<Pick<UploadImageModel, keyof UploadImageModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    name = '';
    key = '';
    fileName = '';
    file: File;

    type = AttachmentType.Image;
    url = '';
}